<script>

import NodeUserInput from '@/components/node/NodeUserInput.vue'
import NodeStep from '@/components/node/NodeStep.vue'
import NodeBaseMixin from '@/mixins/node-base.mixin'
import NodePayload from '@/components/node/NodePayload.vue'
import NodeUserInputFile from '@/components/node/NodeUserInputFile.vue'

const NodeView = {
    nlp_predict: NodeUserInput,
    step: NodeStep,
    payload: NodePayload,
    kb: NodeStep,
    form: NodeStep,
    files: NodeUserInputFile,
    suggestion: NodeStep
}
export default {
    name: 'NodeBox',
    mixins: [NodeBaseMixin],
    props: {
        node: null
    },
    computed: {
        nodeView () {
            return NodeView[this.node.type]
        }
    }

}
</script>

<template>
<div class="node-wrapper" ref="nodeRef">
    <component :is="nodeView" :node="node" @repaint="repaint"></component>
</div>
</template>

<style scoped lang="scss">
.node-wrapper {
  border-radius: 4px;
  border: 1px solid #D2D2D2;
  background: #D2D2D2;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
  max-width: 350px;
}
</style>
